module.exports = __webpack_public_path__ + "img/cross-icon.7a545539.svg";